import { render, staticRenderFns } from "./AppCardHeading.vue?vue&type=template&id=52c540fc&"
import script from "./AppCardHeading.vue?vue&type=script&lang=js&"
export * from "./AppCardHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AppCardHeading.vue"
export default component.exports